<template>
    <div>
        <div class="fadeup-group px-container py-10">
            <div class="xp-markdown">
                <h1 v-if="source === 'pricing-form'">Thank You</h1>
                <h1 v-else><strong>Distributor</strong> stock check</h1>
            </div>
        </div>

        <div class="fadeup-group">
            <div class="fadeup fadeup-2 px-container">
                <div v-if="source === 'pricing-form'" class="pb-10">
                    <div class="flex items-center p-5 border rounded gap-7 border-xp-line-grey">
                        <img
                        class="flex-shrink-0 w-20 h-auto"
                        :src="form_submission_icon"
                        alt=""
                        />
                        <p class="py-8 text-lg font-bold lg:text-xl">Thanks for getting in touch - we will get back to you shortly.</p>
                    </div>
                </div>

                <div v-if="total_data != 0 || source !== 'pricing-form'" class="grid-x grid-padding-x">
                    <div class="cell large-12">
                        <stock-check-search-box :part="part_data"/>
                        <p v-show="error_data" class="mt-2 text-[#de3a35]">Part number must be at least 3 characters.</p>
                    </div>

                    <div class="pt-4 pb-12">
                        <template v-if="is_no_matching_parts_data">
                            <p>
                                <span v-if="is_account" class="font-bold">No matches could be found, please try a different part number.</span>
                                <span v-else class="font-bold">The product you requested is not a stocked item, however our distribution partners do have access to the full XP Power product range through their dedicated Not In Catalogue teams and can be contacted using these email addresses.</span>
                            </p>
                            <div v-if="is_account" class="flex flex-col pt-5 pb-24">
                                <div class="overflow-x-auto">
                                    <div class="inline-block min-w-full align-middle px-6 xl:px-0">
                                        <div class="overflow-hidden border rounded products-table border-xp-line-grey">
                                            <table class="min-w-full divide-y divide-xp-line-grey">
                                                <thead class="bg-xp-light-grey">
                                                    <tr>
                                                        <th class="px-6 py-5 text-left text-sm font-bold uppercase tracking-[2.5px]">
                                                            Distributor
                                                        </th>
                                                        <th class="px-6 py-5 text-left text-sm font-bold uppercase tracking-[2.5px]">
                                                            Contact Email Address
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="continent_iso_data === 'EU' || 'AS'">
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            Farnell
                                                        </td>
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            <a href="mailto:sendtoFarnell@farnell.com">
                                                                <b>sendtoFarnell@farnell.com</b>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="continent_iso_data === 'EU' || 'AS'">
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            RS Components
                                                        </td>
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            <a href="mailto:RSPPSales@rs-components.com">
                                                                <b>RSPPSales@rs-components.com</b>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            Digi-Key
                                                        </td>
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            <a href="mailto:orders@digikey.com">
                                                                <b>orders@digikey.com</b>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="continent_iso_data === 'NA'">
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            Newark
                                                        </td>
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            <a href="mailto:orders@digikey.com">
                                                                <b>orders@digikey.com</b>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            Mouser
                                                        </td>
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            <a href="mailto:sales@mouser.com">
                                                                <b>sales@mouser.com</b>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="continent_iso_data === 'NA'">
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            Allied
                                                        </td>
                                                        <td class="whitespace-nowrap px-6 py-2 tracking-wide text-black font-normal">
                                                            <a href="mailto:customerservice@alliedelec.com">
                                                                <b>customerservice@alliedelec.com</b>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div v-if="loading" class="h-20 mb-12">
                            <p>Searching for matching product models</p>
                            <div class="loading">
                                <div class="lds-ring no-absolute">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        </div>

                        <template v-else-if="Object.keys(stock_data).length && !loading">
                            <template v-if="total_data">
                                <p v-if="Object.keys(stock_data).length && Object.keys(stock_data).length > 1" class="py-8 text-lg font-bold lg:text-xl">These models are available from the following distributors.</p>
                                <p v-else class="py-8 text-lg font-bold lg:text-xl">This model is available from the following distributors.</p>
                            </template>
                            <template v-else>
                                <p class="pt-10 pb-5 text-lg font-bold lg:text-xl">This model is available for backorder from the following distributors.</p>
                            </template>
                            <div class="flex flex-col pb-24">
                                <div class="overflow-x-auto">
                                    <div class="inline-block min-w-full align-middle px-6 xl:px-0">
                                        <div class="overflow-hidden border rounded products-table border-xp-line-grey">
                                            <table class="min-w-full divide-y divide-xp-line-grey">
                                                <thead class="bg-xp-light-grey">
                                                    <tr>
                                                        <th
                                                            width="10%"
                                                            class="min-w-[100px] px-3 py-5 text-left text-sm font-bold uppercase tracking-[2.5px]"
                                                        ></th>
                                                        <th
                                                            width="27%"
                                                            class="min-w-[100px] px-3 py-5 text-left text-sm font-bold uppercase tracking-[2.5px]"
                                                            >Model name
                                                        </th>
                                                        <th
                                                            width="33%"
                                                            class="px-3 py-5 text-left text-sm font-bold uppercase tracking-[2.5px]"
                                                            >Distributor
                                                        </th>
                                                        <th
                                                            width="15%"
                                                            class="px-3 py-5 text-left text-sm font-bold uppercase tracking-[2.5px]"
                                                            >QTY
                                                        </th>
                                                        <th
                                                            width="15%"
                                                            class="px-3 py-5 text-left text-sm font-bold uppercase tracking-[2.5px]"
                                                        ></th>
                                                    </tr>
                                                </thead>
                                                <stock-check-table :endpoint="endpoint" :stock="stock_data"/>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="!Object.keys(stock_data).length && part_data">
                            <p>
                                <strong>Unfortunately, we were unable to find stock of {{ part_data }} in your region. Please get in touchwith us.</strong>
                                <a class="mb-0 ml-1 button" :href="pricing_delivery_url">Contact Us</a>
                            </p>
                        </template>
                        <template v-else>
                            <p>Please enter a part number into the search bar above and click the arrow to search.</p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Hub from '../../events/hub'
import axios from 'axios'
import debounce from 'lodash.debounce'

export default {
    name: 'ParentStockCheck',
    props: {
        source: {
            required: false,
            type: String,
        },
        total: {
            required: false,
            type: String,
        },
        part: {
            required: false,
            type: String,
        },
        form_submission_icon:{
            required: false,
            type: String,
        },
        is_no_matching_parts: {
            required: true,
            type: String,
        },
        is_account: {
            required: false,
            type: String,
        },
        continent_iso:{
            required: false,
            type: String,
        },
        stock:{
            required: false,
            type: String,
        },
        pricing_delivery_url:{
            required: false,
            type: String,
        },
        endpoint:{
            required: false,
            type: String,
        },
    },
    data: () => ({
        stock_data: {},
        total_data: 0,
        part_data: '',
        currentUrl: '',
        is_no_matching_parts_data: false,
        continent_iso_data: null,
        error_data: false,
        loading: false,
    }),
    mounted() {
        this.stock_data = JSON.parse(this.stock)
        this.part_data = this.part
        this.total_data = this.total
    },
    created() {
        Hub.$on('stock-search-input-type', this.search)
        Hub.$on('error-close', this.errorBlockClose)
    },
    beforeDestroy() {
        Hub.$off('error-close', this.errorBlockClose)
    },
    methods: {
        errorBlockClose() {
            this.error_data = false
        },

        updateUrl(queryString) {
            this.currentUrl = `${this.endpoint}?part=${queryString}`;
            history.pushState(null, '', `?part=${queryString}`);
        },

        async getSearchResult(queryString) {
            this.loading = true

            if (queryString.length < 3) {
                this.error_data = true
                this.loading = false
            } else {
                this.error_data = false
                const result = await axios(this.endpoint+'?part='+queryString)
                this.stock_data = result.data.stock
                this.continent_iso_data = result.data.continent_iso
                this.is_no_matching_parts_data = result.data.is_no_matching_parts_data
                this.part_data = queryString
                this.total_data = result.data.total
                this.loading = false
            }
        },

        search: debounce( function (queryString) {
            this.updateUrl(queryString);
            this.getSearchResult(queryString)
        }, 1000)
    }
}
</script>
